import { useEffect, useRef } from 'react';
import { elapsedRatio, seconds } from '../app/clock';
import { sfx } from '../audio/sfx';
import { cx } from './cx';
import s from './ui.module.scss';

/**
 * Le chrono de phase.
 *
 * Une jauge ET un nombre, parce qu'ils ne repondent pas a la meme question :
 * la jauge dit « ou j'en suis », le nombre dit « combien il me reste ». En
 * pleine manche on lit la jauge du coin de l'oeil ; a trois secondes de la
 * fin, c'est le nombre qu'on fixe.
 *
 * L'urgence n'est pas un seuil arbitraire : elle se declenche sous le quart
 * restant, donc elle s'adapte toute seule si la duree des manches change.
 */
export interface CountdownProps {
  remainingMs: number;
  totalMs: number | null;
  label?: string;
}

export function Countdown({ remainingMs, totalMs, label }: CountdownProps) {
  const ratio = elapsedRatio(remainingMs, totalMs);
  const left = seconds(remainingMs);
  const urgent = totalMs !== null && remainingMs < totalMs * 0.25;

  // Un souffle par seconde ENTIERE qui passe, jamais par image : le chrono se
  // rafraichit ~60 fois par seconde, biper a chaque frame serait insupportable.
  const lastTick = useRef(left);
  useEffect(() => {
    if (urgent && left < lastTick.current && left > 0) sfx.tick();
    lastTick.current = left;
  }, [left, urgent]);

  return (
    <div className={cx(s.countdown, urgent && s.countdownUrgent)}>
      {label ? <span className={s.countdownLabel}>{label}</span> : null}

      <div className={s.countdownTrack}>
        <span
          className={s.countdownFill}
          // `scaleX` plutot qu'une largeur : le navigateur compose la
          // transformation, donc la jauge reste fluide meme pendant une
          // animation d'indice.
          style={{ transform: `scaleX(${1 - ratio})` }}
        />
      </div>

      <span className={s.countdownValue} aria-live="off">
        {left}
        <span className={s.countdownUnit}>s</span>
      </span>
    </div>
  );
}
